import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Field } from "formik";
import { Form } from "semantic-ui-react";

import FormikSemanticDropdown from "../../forms/formik/FormikSemanticDropdown.jsx";

import { ESTIMATE_DIMENSIONS } from "../../../state/reducers/projectWizard/projectWizardConstants.js";

import scheduleSelector from "../../../state/reducers/schedules/scheduleSelector.js";
import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class EstimateScheduleSelection extends PureComponent {
  static propTypes = {
    scheduleOptions: PropTypes.array.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "project_wizard.estimate_panel"
  };

  // -- RENDER DATA - //

  getTimeDimensions = () => {
    const { copy } = this.props;

    return [
      {
        text: copy("dimensions.time.monthly"),
        value: ESTIMATE_DIMENSIONS.MONTHLY
      },
      {
        text: copy("dimensions.time.weekly"),
        value: ESTIMATE_DIMENSIONS.WEEKLY
      }
    ];
  };

  // -- RENDER -- //

  render() {
    const { scheduleOptions, copyKey, copy } = this.props;

    return (
      <Form.Group widths="equal">
        <Field
          name={`schedule`}
          label={copy(`${copyKey}.schedule_input.label`)}
          placeholder={copy(`${copyKey}.schedule_input.placeholder`)}
          options={scheduleOptions}
          required={true}
          component={FormikSemanticDropdown}
        />
        <Field
          name={`dimension`}
          label={copy(`${copyKey}.dimension_input.label`)}
          placeholder={copy(`${copyKey}.dimension_input.placeholder`)}
          options={this.getTimeDimensions()}
          required={true}
          component={FormikSemanticDropdown}
        />
      </Form.Group>
    );
  }
}

const mapStateToProps = (state, props) => ({
  scheduleOptions: scheduleSelector.selectSchedulesOptionData(state, props),
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(EstimateScheduleSelection);
